export default __webpack_public_path__ + "static/audit-52cf29b455a9c3eb581ec554a9a1245c.jpg";